import { IAppState } from '../../common/state';
import { DISPLAY_CAROUSEL_MAX_PAGE } from 'shared/constants/newbuildingCarouselOffers';
import { selectCurrentPageNumber } from 'shared/selectors/results';

export const selectIsNewbuildingOffersWithBannerCarouselVisible = (state: IAppState) => {
  const pageNumber = selectCurrentPageNumber(state);

  return (
    pageNumber <= DISPLAY_CAROUSEL_MAX_PAGE &&
    state.newbuildingInformation != null &&
    state.featureToggle.isNewbuildingOffersCarouselEnabled
  );
};
